module.exports = __webpack_public_path__ + "static/media/renault_logo.df8c55d6.png";